export default __webpack_public_path__ + "static/media/Not-login-alert.be4b5317.svg";